import React, { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import {
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  Typography,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { TextFieldList } from 'components'

const ControlledRadioGroup = ({ value, onChange, children }) => {
  const handleChange = (event) => {
    onChange(event.target.value)
  }

  return (
    <RadioGroup value={value || ''} onChange={handleChange}>
      {children}
    </RadioGroup>
  )
}

const EmailSection = ({
  users,
  isLoading,
  requireApproval,
  setDisabledNextButton,
}) => {
  const { control, errors, watch } = useFormContext()
  const approvalType = watch('approvalType')
  const approvalUser = watch('approvalUser')
  const approvalEmailList = watch('approvalEmailList')

  useEffect(() => {
    if (requireApproval) {
      if (approvalType === 'user') {
        const isUserSelected = approvalUser && approvalUser.length > 0
        setDisabledNextButton(!isUserSelected)
      } else if (approvalType === 'email') {
        const isEmailFilled = approvalEmailList && approvalEmailList.length > 0
        setDisabledNextButton(!isEmailFilled)
      } else {
        setDisabledNextButton(true)
      }
    } else {
      setDisabledNextButton(false)
    }
  }, [
    requireApproval,
    approvalType,
    approvalUser,
    approvalEmailList,
    setDisabledNextButton,
  ])

  return (
    <Box display="flex" flexDirection="column" mt={2}>
      <Controller
        as={
          <ControlledRadioGroup>
            <Box mb={2}>
              <FormControlLabel
                value="user"
                control={<Radio color="primary" />}
                label="Selecionar usuário da plataforma"
              />

              {approvalType === 'user' && (
                <>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ marginLeft: 32, marginBottom: 16 }}
                  >
                    Selecionar um ou mais usuários previamente cadastrados na
                    sua organização
                  </Typography>
                  <Controller
                    as={
                      <Autocomplete
                        multiple
                        filterSelectedOptions
                        disabled={approvalType !== 'user'}
                        noOptionsText="Nenhum usuário encontrado"
                        options={users}
                        getOptionLabel={(option) => option.name}
                        getOptionSelected={(option, value) =>
                          option.id === value.id
                        }
                        loading={isLoading}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Digite o nome do usuário"
                            variant="outlined"
                            error={
                              approvalType === 'user' && !!errors?.approvalUser
                            }
                            helperText={
                              approvalType === 'user'
                                ? errors?.approvalUser?.message
                                : ''
                            }
                          />
                        )}
                      />
                    }
                    control={control}
                    name="approvalUser"
                    onChange={([, data]) => data}
                  />
                </>
              )}
            </Box>

            <Box>
              <FormControlLabel
                value="email"
                control={<Radio color="primary" />}
                label="Enviar por e-mail"
              />

              {approvalType === 'email' && (
                <>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ marginLeft: 32, marginBottom: 16 }}
                  >
                    Caso o aprovador ainda não tenha conta, ele poderá acessar o
                    documento por um link seguro, se identificar e aprovar sem
                    precisar se cadastrar -- ou optar por criar uma conta para
                    acompanhar aprovações futuras.
                  </Typography>
                  <TextFieldList
                    label="Adicionar e-mail"
                    controlName="approvalEmailInput"
                    arrayControlName="approvalEmailList"
                    containerTitle="E-mails adicionados"
                    disabled={approvalType !== 'email'}
                  />
                </>
              )}
            </Box>
          </ControlledRadioGroup>
        }
        control={control}
        name="approvalType"
      />
    </Box>
  )
}

export default EmailSection
